import { Link } from "react-router-dom";
import GMTIcon from "../../../img/svg/gmtIcon";
// import heroImage from "../../../../about_hero_watch_luxury_1776104339671.png";

export default function About({ isMobile }: { isMobile: boolean, currentImage: string }) {

    return (
        <main className="bg-white pb-32 overflow-hidden">
            {/* Hero Section */}
            <div className="relative h-[40vh] md:h-[60vh] w-full bg-primary flex items-center justify-center overflow-hidden">
                {/* <img 
                    src={heroImage} 
                    alt="Luxury Watchmaking" 
                    className="absolute inset-0 w-full h-full object-cover opacity-60 scale-105" 
                /> */}
                <div className="absolute inset-0 bg-gradient-to-b from-primary/80 via-primary/40 to-primary/90" />

                <div className="relative z-10 text-center px-4 pt-20 animate-superfade">
                    <p className="text-secondary font-bold tracking-[0.4em] text-xs uppercase mb-6">Nossa História</p>
                    <h1 className="font-outfit text-4xl md:text-7xl font-black text-white tracking-widest mb-8">
                        SOBRE O GMT-3
                    </h1>
                    <div className="flex justify-center">
                        <div className="w-20 h-1 bg-secondary rounded-full" />
                    </div>
                </div>
            </div>

            <div className="max-w-4xl mx-auto px-6 mt-24 space-y-32">
                {/* Intro Section */}
                <section className="text-center space-y-8 animate-superfade">
                    <h2 className="text-3xl md:text-5xl font-black text-primary leading-tight">
                        Desvendando o Universo <br className="hidden md:block" /> da <span className="text-secondary">Relojoaria</span>
                    </h2>
                    <p className="text-xl text-mono leading-relaxed">
                        O GMT-3 é uma referência no mundo da relojoaria, trazendo conhecimento, curiosidades e orientações para os amantes de relógios de luxo.
                    </p>
                </section>

                {/* Content Grid */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-center">
                    <div className="space-y-6">
                        <div className="w-12 h-1 bg-secondary" />
                        <h3 className="text-2xl font-black text-primary uppercase tracking-widest">A Jornada</h3>
                        <p className="text-mono leading-relaxed">
                            Fundada em 2016, a marca surgiu da paixão de Leandro por relógios e da necessidade de compartilhar informações em português em um mercado onde o conteúdo disponível era majoritariamente em inglês.
                        </p>
                    </div>
                    <div className="bg-moninho aspect-square rounded-[3rem] p-12 flex items-center justify-center shadow-xl shadow-primary/5">
                        <GMTIcon fill="#111827" width="200" />
                    </div>
                </div>

                {/* Values Section */}
                <section className="bg-primary rounded-[3rem] p-12 md:p-20 text-white relative overflow-hidden shadow-2xl">
                    <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12">
                        <div className="space-y-6">
                            <h3 className="text-secondary font-bold tracking-widest text-sm uppercase">Valores</h3>
                            <h2 className="text-3xl md:text-4xl font-black leading-tight">Imparcialidade e Verdade</h2>
                        </div>
                        <p className="text-white/70 text-lg leading-relaxed pt-2">
                            Leandro sempre priorizou a transparência em suas análises e reviews, conquistando a confiança de milhares de seguidores e tornando o GMT-3 o maior canal de relógios em língua portuguesa do mundo.
                        </p>
                    </div>
                    {/* Decorative Element */}
                    <div className="absolute top-0 right-0 w-64 h-64 bg-secondary/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2" />
                </section>

                {/* The Marketplace Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-20 items-center">
                    <div className="order-2 md:order-1 relative">
                        <div className="absolute -inset-4 bg-secondary/10 rounded-[3rem] blur-2xl" />
                        <div className="relative bg-white border border-primary/5 p-8 rounded-[2rem] shadow-xl">
                            <div className="space-y-4">
                                <div className="flex items-center gap-3">
                                    <div className="w-2 h-2 bg-secondary rounded-full" />
                                    <span className="text-xs font-black tracking-widest text-primary uppercase">Segurança</span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="w-2 h-2 bg-secondary rounded-full" />
                                    <span className="text-xs font-black tracking-widest text-primary uppercase">Autenticidade</span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <div className="w-2 h-2 bg-secondary rounded-full" />
                                    <span className="text-xs font-black tracking-widest text-primary uppercase">Credibilidade</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="order-1 md:order-2 space-y-6 text-right">
                        <div className="w-12 h-1 bg-secondary ml-auto" />
                        <h3 className="text-2xl font-black text-primary uppercase tracking-widest">Os Classificados</h3>
                        <p className="text-mono leading-relaxed">
                            Uma plataforma que visa unir compradores e vendedores de forma segura, criando um ambiente onde a credibilidade e a qualidade sejam as prioridades absolutas de cada negociação.
                        </p>
                    </div>
                </div>

                {/* Final Call */}
                <section className="text-center pt-20 border-t border-surface">
                    <p className="text-xl text-primary font-medium max-w-2xl mx-auto leading-relaxed mb-12 italic">
                        "O GMT-3 é muito mais do que um canal de relógios. É uma comunidade de apaixonados guiada pela paixão e pela transparência."
                    </p>
                    <Link
                        to="/"
                        className="inline-block py-5 px-12 bg-primary text-secondary font-black tracking-[0.2em] text-xs rounded-2xl hover:bg-primary/95 transition-all shadow-xl shadow-primary/20 hover:scale-105 active:scale-95"
                    >
                        EXPLORAR PLATAFORMA
                    </Link>
                </section>
            </div>
        </main>
    )
}

